import type { Config } from 'dompurify'

// Allowlist safe URI schemes; also permits relative URLs (no scheme).
// Pattern: explicit safe schemes, or strings that can't be a scheme (no leading alpha+colon).
const SAFE_URI_REGEXP =
  /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i

/**
 * DOMPurify options for RichEditor and other stored HTML rendered in the product.
 * Kept in one module so care-office and ui-kit stay aligned on v3's {@link Config} shape.
 */
export const storedHtmlDomPurifyConfig = {
  ALLOWED_URI_REGEXP: SAFE_URI_REGEXP
} satisfies Config
